'use strict';

const DrawGrid = require('./core/DrawGrid');

/**
 * core modules
 * @type {Object}
 * @namespace cheetahGrid.core
 * @memberof cheetahGrid
 */
module.exports = {
	DrawGrid
};
